import React, { useEffect, useState, useCallback } from "react";
import { ChatCardProps } from "./ChatCard";
// import { getSeedFileInfo } from "../../../api";
import { delete_user_data_from_client_side } from "../../../utils/common";
import { useNavigate } from "react-router-dom";
import { getSeedFileInfo } from "../../../api/axiosApi";

export const RenderCitations = ({ isLoading, citations, onCitationClick }: ChatCardProps) => {
    const navigate = useNavigate();
    const [citationUrls, setCitationUrls] = useState<Record<string, string>>({});

    function onCitationClicked(path: any): void {
        if (onCitationClick) {
            onCitationClick(path);
        }
    }

    return (
        <>
            {!isLoading && citations && Array.isArray(citations) && citations.length > 0 ? (
                <div>
                    <div className="text-sm text-gray-500 overflow-auto">
                        <b className="text-green-950 pl-2">Citations:</b>
                        {Array.isArray(citations) && (
                            <ol className="list-decimal pl-6">
                                {citations.map((item: any, index) => (
                                    <li key={index}>
                                        {item.link !== "" ? (
                                            <a
                                                href={item.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="cursor-pointer text-blue-600 hover:underline"
                                            >
                                                {item.title} <i> by {item.author}</i>
                                            </a>
                                        ) : (
                                            <a
                                                rel="noopener noreferrer"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    onCitationClicked(item.citation);
                                                }}
                                                className="cursor-pointer text-blue-600 hover:underline"
                                            >
                                                {item.title} <i> by {item.author}</i>
                                            </a>
                                        )}
                                    </li>
                                ))}
                            </ol>
                        )}
                    </div>
                </div>
            ) : (
                ""
            )}
        </>
    );
};
